<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-contenido">
      <LoadingOverlay :visible="loading" message="Cargando instrumento..." />
      <LoadingOverlay :visible="loadingAccion" :message="loadingMensaje" />

      <div v-if="!loading" class="wrap">
        <header class="top">
          <h1>{{ modoEdicion ? 'Modificar instrumento' : 'Instrumentos' }}</h1>
          <p>Registro de instrumentos de evaluación</p>
        </header>

        <main>
          <!-- Estado actual (solo modo edición) -->
          <div v-if="modoEdicion && editandoInstrumento?.estado" class="estado-bar">
            <span class="estado-label">Estado actual:</span>
            <span :class="['estado-badge', `estado-${editandoInstrumento.estado}`]">
              {{ editandoInstrumento.estado }}
            </span>
          </div>

          <!-- Selector de instrumentos -->
          <section class="card">
            <h2>Seleccione un instrumento</h2>
            <div class="fila-selector">
              <select v-model="nombreInstrumento" class="input-flex">
                <option disabled value="">Seleccione...</option>
                <option v-for="inst in opcionesInstrumentos" :key="inst" :value="inst">
                  {{ inst }}
                </option>
              </select>
              <button class="btn guardar" @click="mostrarFormInstrumento = true">Agregar nuevo</button>
            </div>

            <!-- Formulario nuevo instrumento (local) -->
            <div v-if="mostrarFormInstrumento" class="sub-card">
              <h3>Nuevo instrumento</h3>
              <div class="form-group">
                <label>Nombre</label>
                <input type="text" v-model="nombreInstrumento" />
              </div>
              <div class="form-group">
                <label>Descripción</label>
                <textarea v-model="descripcionInstrumento"></textarea>
              </div>
              <div class="botones">
                <button class="btn salir" @click="mostrarFormInstrumento = false">Cancelar</button>
                <button class="btn guardar" @click="nuevoInstrumentoLocal">Agregar instrumento</button>
              </div>
            </div>
          </section>

          <!-- Datos del formulario (solo tipo opinión) -->
          <section v-if="instrumentoSeleccionado && requiereGruposYPreguntas()" class="card">
            <h2>Datos del formulario</h2>
            <p class="card-desc">Al guardar se generará un formulario de Google Forms con las preguntas del instrumento.</p>
            <div class="form-group">
              <label>Nombre del formulario</label>
              <input type="text" v-model="nombreFormulario" placeholder="Ej: Encuesta de percepción — Reglamento estudiantil" />
            </div>
            <div class="form-group">
              <label>Instrucciones (se muestran dentro del formulario)</label>
              <textarea v-model="instruccionesFormulario" rows="3" placeholder="Ej: Responda con sinceridad. Sus respuestas son confidenciales."></textarea>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>Vigencia desde</label>
                <input type="date" v-model="vigenciaDesde" />
              </div>
              <div class="form-group">
                <label>Vigencia hasta</label>
                <input type="date" v-model="vigenciaHasta" />
              </div>
            </div>
          </section>

          <!-- Sección de grupos y preguntas SOLO si el tipo requiere -->
          <section v-if="instrumentoSeleccionado && requiereGruposYPreguntas()" class="card">
            <h2>Grupos de interés</h2>

            <!-- Selector de grupos -->
            <div class="fila-selector">
              <select v-model="grupoSeleccionado" class="input-flex">
                <option disabled value="">Seleccione un grupo...</option>
                <option v-for="g in grupoStore.grupos" :key="g.id_grupo_interes" :value="g">
                  {{ g.nombre }}
                </option>
              </select>
              <button class="btn guardar" @click="mostrarGrupoForm = true">Agregar nuevo</button>
            </div>
            <div v-if="grupoSeleccionado && instrumentoSeleccionado" class="botones">
              <button class="btn vincular" @click="vincularGrupoSeleccionado">
                Vincular grupo seleccionado
              </button>
            </div>

            <!-- Formulario nuevo grupo (local) -->
            <div v-if="mostrarGrupoForm" class="sub-card">
              <h3>Nuevo grupo de interés</h3>
              <div class="form-group">
                <label>Estamento</label>
                <input type="text" v-model="nombreGrupo" />
              </div>
              <div class="form-group">
                <label>Tipo de muestreo</label>
                <input type="text" v-model="tipoMuestreo" />
              </div>
              <div class="form-group">
                <label>Criterios</label>
                <textarea v-model="criterio"></textarea>
              </div>
              <div class="botones">
                <button class="btn salir" @click="mostrarGrupoForm = false">Cancelar</button>
                <button class="btn guardar" @click="agregarGrupoLocal">Guardar grupo</button>
              </div>
            </div>

            <!-- Grupos vinculados: tabs -->
            <div v-if="instrumentoSeleccionado?.grupos_interes?.length > 0" class="grupos-vinculados">
              <h3>Grupos vinculados</h3>
              <div class="grupo-selector">
                <button
                  v-for="g in instrumentoSeleccionado.grupos_interes"
                  :key="g.id_temp || g.id_grupo_interes"
                  :class="['grupo-btn', grupoActivo === g ? 'active' : '']"
                  @click="grupoActivo = g"
                >
                  {{ g.nombre }}
                </button>
              </div>

              <div v-if="!grupoActivo" class="hint-seleccionar-grupo">
                <div class="hint-seleccionar-flecha">
                  <span v-for="g in instrumentoSeleccionado.grupos_interes" :key="g.id_temp || g.id_grupo_interes" class="hint-flecha-item">↑</span>
                </div>
                <p class="hint-seleccionar-texto">Pulse sobre un grupo para ver y agregar sus preguntas</p>
              </div>

              <!-- Preguntas del grupo activo -->
              <div v-if="grupoActivo" class="preguntas-panel">
                <div class="preguntas-head">
                  <h4>Preguntas de {{ grupoActivo.nombre }}</h4>
                  <span v-if="grupoActivo.preguntas?.length" class="pill">
                    {{ grupoActivo.preguntas.length }}
                  </span>
                </div>

                <div
                  v-for="(p, idx) in grupoActivo.preguntas"
                  :key="p.id_temp || p.id_pregunta"
                  class="q"
                >
                  <div class="qh">
                    <span class="qn">{{ Number(idx) + 1 }}</span>
                    <span class="qt">{{ p.enunciado }}</span>
                    <span v-if="p.tipo_respuesta" class="tag">{{ etiquetaTipo(p.tipo_respuesta) }}</span>
                  </div>

                  <ul v-if="Array.isArray(p.opciones) && p.opciones.length" class="opciones">
                    <li v-for="(op, i) in p.opciones" :key="i">{{ op }}</li>
                  </ul>

                  <div v-if="p.tipo_respuesta === 'long_text'" class="resp-show">
                    <span class="muted">Respuesta del usuario…</span>
                  </div>

                  <div v-if="p.tipo_respuesta === 'rating'" class="rating">
                    <span class="muted">Escala:</span>
                    <span v-for="n in p.opciones" :key="n" class="rating-opt">{{ n }}</span>
                  </div>

                  <div v-if="p.tipo_respuesta === 'opinion'" class="tabla-opinion">
                    <table class="tabla-evaluacion">
                      <thead>
                        <tr>
                          <th>Variante</th>
                          <th v-for="(c, i) in p.criterios" :key="i">{{ c }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(v, i) in p.variantes" :key="i">
                          <td>{{ v }}</td>
                          <td v-for="(c, j) in p.criterios" :key="j">
                            <input type="checkbox" disabled />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="botones">
                    <button
                      v-if="(instrumentoSeleccionado?.grupos_interes?.length ?? 0) > 1 && preguntaCopiar !== p"
                      class="btn guardar btn-sm"
                      type="button"
                      @click.stop="abrirCopia(p)"
                    >
                      Copiar a...
                    </button>
                    <button type="button" class="btn salir btn-sm" @click.stop="eliminarPregunta(grupoActivo, p.id_temp)">
                      Eliminar
                    </button>
                  </div>

                  <!-- Panel de copia inline -->
                  <div v-if="preguntaCopiar === p" class="copia-panel">
                    <p class="copia-titulo">Selecciona los grupos destino:</p>
                    <div class="grupos-check-list">
                      <label
                        v-for="g in otrosGrupos"
                        :key="g.id_temp ?? g.id_grupo_interes"
                        class="grupo-check-item"
                      >
                        <input type="checkbox" :value="g.id_temp ?? g.id_grupo_interes" v-model="gruposCopiaDestino" />
                        {{ g.nombre }}
                      </label>
                    </div>
                    <div class="botones">
                      <button type="button" class="btn salir btn-sm" @click.stop="cancelarCopia">Cancelar</button>
                      <button
                        type="button"
                        class="btn guardar btn-sm"
                        :disabled="gruposCopiaDestino.length === 0 || copiando"
                        @click.stop="copiarPreguntaAGrupos"
                      >
                        {{ copiando ? 'Copiando...' : 'Copiar' }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="botones">
                  <button class="btn salir" @click="quitarGrupo(grupoActivo)">Quitar grupo</button>
                  <button v-if="authStore.tienePermiso('banco.ver')" class="btn guardar" @click="mostrarBancoModal = true">Sugerir del banco</button>
                  <button class="btn guardar" @click="mostrarFormPregunta = true">Agregar pregunta</button>
                </div>
              </div>
            </div>

            <!-- Formulario nueva pregunta (local) -->
            <div v-if="mostrarFormPregunta" class="sub-card">
              <h4>Nueva pregunta</h4>
              <div class="form-group">
                <label>Tipo de pregunta</label>
                <select v-model="tipoPregunta">
                  <option disabled value="">Seleccione...</option>
                  <option value="single_choice">Opción única</option>
                  <option value="multiple_choice">Casillas (opción múltiple)</option>
                  <option value="desplegable">Lista desplegable</option>
                  <option value="escala_likert">Escala Likert (1–5)</option>
                  <option value="escala_lineal">Escala lineal (configurable)</option>
                  <option value="respuesta_corta">Respuesta corta</option>
                  <option value="long_text">Párrafo (respuesta larga)</option>
                  <option value="fecha">Fecha</option>
                  <option value="hora">Hora</option>
                  <option value="opinion">Pregunta opinión</option>
                </select>
              </div>
              <div class="form-group">
                <label>Enunciado</label>
                <input type="text" v-model="enunciadoPregunta" />
              </div>

              <!-- Opciones (solo tipos de selección) -->
              <div v-if="esTipoSeleccionPregunta" class="form-group">
                <label>Opciones (una por línea, mínimo 2)</label>
                <textarea v-model="opcionesTextoPregunta" rows="4" placeholder="Opción 1&#10;Opción 2&#10;Opción 3"></textarea>
              </div>

              <!-- Configuración de escala lineal -->
              <div v-else-if="tipoPregunta === 'escala_lineal'" class="escala-config">
                <div class="form-group">
                  <label>Desde</label>
                  <select v-model.number="escalaMinPregunta">
                    <option :value="0">0</option>
                    <option :value="1">1</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Hasta</label>
                  <select v-model.number="escalaMaxPregunta">
                    <option v-for="n in 9" :key="n" :value="n + 1">{{ n + 1 }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Etiqueta mínima (opcional)</label>
                  <input type="text" v-model="etiquetaMinPregunta" placeholder="Ej: Malo" />
                </div>
                <div class="form-group">
                  <label>Etiqueta máxima (opcional)</label>
                  <input type="text" v-model="etiquetaMaxPregunta" placeholder="Ej: Excelente" />
                </div>
              </div>

              <div class="botones">
                <button class="btn salir" @click="cancelarPregunta">Cancelar</button>
                <button
                  class="btn guardar"
                  :disabled="!puedeGuardarPreguntaLocal"
                  @click="agregarPreguntaLocal(grupoActivo)"
                >
                  Guardar pregunta
                </button>
              </div>
            </div>
          </section>

          <!-- Botones finales -->
          <div class="botones botones-finales">
            <button class="btn salir" @click="salir" :disabled="loadingAccion">Salir</button>
            <button
              v-if="modoEdicion ? authStore.tienePermiso('instrumentos.editar') : authStore.tienePermiso('instrumentos.crear')"
              class="btn guardar"
              @click="guardarInstrumento()"
              :disabled="loadingAccion"
            >
              {{ loadingAccion ? 'Guardando…' : (modoEdicion ? 'Guardar cambios' : 'Guardar instrumento') }}
            </button>
          </div>
        </main>
      </div>

      <MensajeFlotante
        :visible="mensajeVisible"
        :mensaje="mensajeTexto"
        :tipo="mensajeTipo"
        @cerrar="mensajeVisible = false"
      />
    </div>

    <BancoPreguntasSugerenciasModal
      v-model="mostrarBancoModal"
      :idTipoComponente="props.idTipoComponente"
      :nombreComponente="tipoComponenteActual?.nombre ?? tipoComponenteActual?.tipo"
      @agregar="agregarDesdeBanco"
    />
  </div>
</template>

<script lang="ts" setup>
/**
 * Construcción y ciclo de vida de los instrumentos.
 *
 * Máquina de estados edicion → aprobado → asignado → completado. Al completarse
 * el instrumento pasa al repositorio reutilizable y ya no vuelve a edición.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref, onMounted, computed } from 'vue'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionGrupoInteres } from '@/store/GestionGrupoInteres'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import type GrupoInteres from '@/interfaces/GrupoInteres'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import { useGestionBancoPreguntas } from '@/store/GestionBancoPreguntas'
import { primerError } from '@/services/http'
import type TipoComponente from '@/interfaces/TipoComponente'
import type Instrumento from '@/interfaces/Instrumetos'
import { watch } from 'vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import useAutenticar from '@/store/IngresoAutenticar'
import BancoPreguntasSugerenciasModal from '@/components/BancoPreguntasSugerenciasModal.vue'

const instrumentoStore = useGestionInstrumento()
const grupoStore = useGestionGrupoInteres()
const preguntaStore = useGestionPreguntas()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const tipoComponenteStore = useGestionTipoComponente()
const configStore = useGestionConfiguracionInstrumento()
const bancoStore = useGestionBancoPreguntas()
const tipoComponenteActual = ref<TipoComponente | null>(null)
const variantesOpinion = ref<string[]>([])
const props = defineProps<{
  visible: boolean,
  idTipoComponente: number,
  idIndicador: number,
  idInstrumento?: number | null
}>()
const emit = defineEmits<{
  cerrar: []
}>()
const authStore = useAutenticar()
const loading = ref(false)
const loadingAccion = ref(false)
const loadingMensaje = ref('Guardando instrumento...')
const modoEdicion = ref(false)
const instrumentoSeleccionado = ref<any>(null)
const mostrarFormInstrumento = ref(false)
const nombreInstrumento = ref('')
const descripcionInstrumento = ref('')
const grupoSeleccionado = ref<any>(null)
const mostrarGrupoForm = ref(false)
const grupoActivo = ref<any>(null)
const nombreGrupo = ref('')
const tipoMuestreo = ref('')
const criterio = ref('')
const mostrarFormPregunta = ref(false)
const preguntaCopiar = ref<any>(null)
const gruposCopiaDestino = ref<(number | string)[]>([])
const copiando = ref(false)
const mostrarBancoModal = ref(false)
const tipoPregunta = ref('')
const enunciadoPregunta = ref('')
const opcionesPregunta = ref<string[]>([])
const opcionesTextoPregunta = ref('')
const escalaMinPregunta = ref(1)
const escalaMaxPregunta = ref(5)
const etiquetaMinPregunta = ref('')
const etiquetaMaxPregunta = ref('')
const TIPOS_SELECCION_PREGUNTA = ['single_choice', 'multiple_choice', 'desplegable']
const esTipoSeleccionPregunta = computed(() => TIPOS_SELECCION_PREGUNTA.includes(tipoPregunta.value))
function opcionesPreguntaDesdeTexto(): string[] {
  return opcionesTextoPregunta.value.split('\n').map(o => o.trim()).filter(Boolean)
}
const puedeGuardarPreguntaLocal = computed(() => {
  if (!enunciadoPregunta.value.trim() || !tipoPregunta.value) return false
  if (esTipoSeleccionPregunta.value) return opcionesPreguntaDesdeTexto().length >= 2
  return true
})
function construirOpcionesPregunta(): string[] | Record<string, unknown> {
  if (tipoPregunta.value === 'opinion') return []
  if (esTipoSeleccionPregunta.value) return opcionesPreguntaDesdeTexto()
  if (tipoPregunta.value === 'escala_lineal') {
    return {
      min: escalaMinPregunta.value,
      max: escalaMaxPregunta.value,
      etiqueta_min: etiquetaMinPregunta.value.trim() || undefined,
      etiqueta_max: etiquetaMaxPregunta.value.trim() || undefined,
    }
  }
  return []
}
const editandoInstrumento = ref<Instrumento | null>(null)
const tipoInstrumentoId = ref<number | ''>('')
const gruposInteres = ref<any[] | null>(null)
const criteriosOpinion = ref<string[]>([])
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')
const feedback = ref('')
const vigenciaDesde = ref('')
const vigenciaHasta = ref('')
const nombreFormulario = ref('')
const instruccionesFormulario = ref('')

const instrumentosPorTipo = ref<Record<string, string[]>>({
  'documental': ['Ficha de revisión Documental'],
  'cuantitativa': ['Ficha de revisión de indicadores Estadísticos'],
  'opinión': ['Encuesta', 'Entrevista', 'Grupos Focales', 'Observación', 'Mesa-Taller']
})

function etiquetaTipo(tipo: string): string {
  const map: Record<string, string> = {
    single_choice: 'Opción única',
    opcion_unica: 'Opción única',
    opcion_multiple: 'Opción única',
    multiple_choice: 'Casillas',
    casillas: 'Casillas',
    checkbox: 'Casillas',
    desplegable: 'Lista desplegable',
    dropdown: 'Lista desplegable',
    opinion: 'Opinión',
    long_text: 'Párrafo',
    parrafo: 'Párrafo',
    texto: 'Párrafo',
    respuesta_corta: 'Respuesta corta',
    numerica: 'Respuesta corta',
    escala_likert: 'Escala Likert',
    escala_lineal: 'Escala lineal',
    linear_scale: 'Escala lineal',
    rating: 'Escala lineal',
    fecha: 'Fecha',
    hora: 'Hora'
  }
  return map[tipo] || tipo
}

watch(nombreInstrumento, (nuevo) => {
  if (!nuevo) {
    instrumentoSeleccionado.value = null
    return
  }
  instrumentoSeleccionado.value = {
    herramienta: nuevo,
    descripcion: '',
    id_tipo_componente: props.idTipoComponente,
    grupos_interes: []
  }
})

const opcionesInstrumentos = computed(() => {
  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  const clave = Object.keys(instrumentosPorTipo.value).find(k => nombre.includes(k))
  return clave ? instrumentosPorTipo.value[clave] : []
})

function requiereGruposYPreguntas(): boolean {
  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  return nombre.includes('opinión') || nombre.includes('opinion')
}

const gruposVinculados = computed(() => {
  if (!instrumentoSeleccionado.value?.gruposInteres) return []
  return instrumentoSeleccionado.value.gruposInteres
})

const otrosGrupos = computed(() => {
  const todos = instrumentoSeleccionado.value?.grupos_interes ?? []
  const claveActivo = grupoActivo.value?.id_temp ?? grupoActivo.value?.id_grupo_interes
  return todos.filter((g: any) => (g.id_temp ?? g.id_grupo_interes) !== claveActivo)
})

function onModificarInstrumento(instrumento: Instrumento) {
  editandoInstrumento.value = instrumento
  nombreInstrumento.value = instrumento.herramienta
  descripcionInstrumento.value = instrumento.descripcion
  tipoInstrumentoId.value = instrumento.id_tipo_componente
  gruposInteres.value = instrumento.grupos_interes ?? null
  mostrarFormInstrumento.value = true
}

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

async function cargarDatosInstrumento() {
  mensajeVisible.value = false
  modoEdicion.value = false
  editandoInstrumento.value = null
  nombreInstrumento.value = ''
  descripcionInstrumento.value = ''
  vigenciaDesde.value = ''
  vigenciaHasta.value = ''
  nombreFormulario.value = ''
  instruccionesFormulario.value = ''
  instrumentoSeleccionado.value = null
  grupoSeleccionado.value = null
  grupoActivo.value = null
  mostrarFormInstrumento.value = false
  mostrarGrupoForm.value = false
  mostrarFormPregunta.value = false

  loading.value = true

  try {
    const cargarGrupos = grupoStore.getGrupos()
    const cargarTipo = props.idTipoComponente
      ? tipoComponenteStore.getTipoById(props.idTipoComponente)
      : Promise.resolve(null)

    const [, tipo] = await Promise.all([cargarGrupos, cargarTipo])
    tipoComponenteActual.value = tipo

    if (props.idInstrumento) {
      const instrumento = await instrumentoStore.getInstrumentoById(props.idInstrumento)
      if (instrumento) {
        modoEdicion.value = true
        editandoInstrumento.value = instrumento
        nombreInstrumento.value = instrumento.herramienta
        descripcionInstrumento.value = instrumento.descripcion ?? ''

        const preguntasPorGrupo = await instrumentoStore.getPreguntasPorGrupo(props.idInstrumento)
        const gruposCargados = (preguntasPorGrupo as any)?.grupos ?? []

        instrumentoSeleccionado.value = {
          id_instrumento: instrumento.id_instrumento,
          herramienta: instrumento.herramienta,
          descripcion: instrumento.descripcion,
          id_tipo_componente: instrumento.id_tipo_componente,
          grupos_interes: gruposCargados.map((g: any) => ({
            id_grupo_interes: g.grupo?.id_grupo_interes ?? null,
            nombre: g.nombre_grupo,
            preguntas: (g.preguntas ?? []).map((p: any) => ({
              id_pregunta: p.id_pregunta,
              enunciado: p.pregunta ?? p.enunciado,
              tipo_respuesta: p.tipo ?? p.tipo_respuesta,
              opciones: p.opciones ?? [],
              variantes: p.variantes ?? [],
              criterios: p.criterios ?? []
            }))
          })).filter((g: any) => g.id_grupo_interes !== null)
        }

        if (requiereGruposYPreguntas()) {
          await configStore.listar({ id_instrumento: props.idInstrumento! })
          const configActiva = configStore.configuraciones.find(
            c => c.estado === 'publicada' || c.estado === 'borrador'
          ) ?? configStore.configuraciones[0] ?? null
          if (configActiva) {
            vigenciaDesde.value = configActiva.vigencia_desde.slice(0, 10)
            vigenciaHasta.value = configActiva.vigencia_hasta.slice(0, 10)
            nombreFormulario.value = configActiva.titulo ?? ''
            instruccionesFormulario.value = configActiva.instrucciones ?? ''
          }
        }
      }
    }
  } catch (e: any) {
    console.error('Error al cargar datos del instrumento:', e)
    mostrarMensaje('Error al cargar datos del instrumento', 'error')
  } finally {
    loading.value = false
  }
}

watch(
  () => [props.visible, props.idTipoComponente, props.idIndicador, props.idInstrumento] as const,
  ([nuevoVisible, nuevoTipo, nuevoIndicador, nuevoInstrumento], [viejoVisible, viejoTipo, viejoIndicador, viejoInstrumento]) => {
    const seAbrio = nuevoVisible && !viejoVisible
    const cambioPropId = nuevoVisible && (
      nuevoTipo !== viejoTipo ||
      nuevoIndicador !== viejoIndicador ||
      nuevoInstrumento !== viejoInstrumento
    )
    if (seAbrio || cambioPropId) {
      cargarDatosInstrumento()
    }
  }
)

onMounted(async () => {
  if (props.visible) {
    await cargarDatosInstrumento()
  }
})

function vincularGrupoSeleccionado() {
  if (!instrumentoSeleccionado.value) return
  if (!grupoSeleccionado.value) return

  const yaVinculado = instrumentoSeleccionado.value.grupos_interes?.some(
    (g: GrupoInteres) => g.id_grupo_interes === grupoSeleccionado.value.id_grupo_interes
  )
  if (yaVinculado) {
    console.warn('Este grupo ya está vinculado al instrumento')
    grupoSeleccionado.value = null
    return
  }

  if (!instrumentoSeleccionado.value.grupos_interes) {
    instrumentoSeleccionado.value.grupos_interes = []
  }

  const grupoConPreguntas = {
    ...grupoSeleccionado.value,
    preguntas: grupoSeleccionado.value.preguntas ?? []
  }

  instrumentoSeleccionado.value.grupos_interes.push(grupoConPreguntas)
  grupoSeleccionado.value = null
  grupoActivo.value = grupoConPreguntas
}

function nuevoInstrumentoLocal() {
  const nuevoNombre = nombreInstrumento.value

  instrumentoSeleccionado.value = {
    herramienta: nuevoNombre,
    descripcion: descripcionInstrumento.value,
    id_tipo_componente: props.idTipoComponente,
    grupos_interes: []
  }

  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  const clave = Object.keys(instrumentosPorTipo.value).find(k => nombre.includes(k))
  if (clave && !instrumentosPorTipo.value[clave].includes(nuevoNombre)) {
    instrumentosPorTipo.value[clave].push(nuevoNombre)
  }

  mostrarFormInstrumento.value = false
}

function agregarGrupoLocal() {
  if (!requiereGruposYPreguntas()) return

  const nuevo = {
    id_temp: Date.now(),
    nombre: nombreGrupo.value,
    tipo_muestreo: tipoMuestreo.value,
    criterios: criterio.value,
    preguntas: []
  }
  instrumentoSeleccionado.value?.grupos_interes.push(nuevo)
  grupoActivo.value = nuevo
  nombreGrupo.value = ''
  tipoMuestreo.value = ''
  criterio.value = ''
  mostrarGrupoForm.value = false
}

function agregarDesdeBanco(preguntas: any[]) {
  if (!grupoActivo.value) return
  const base = Date.now()
  preguntas.forEach((p, i) => {
    grupoActivo.value.preguntas.push({
      id_temp: base + i,
      id_pregunta_banco: p.id_pregunta ?? null,
      enunciado: p.enunciado || p.pregunta || '',
      tipo_respuesta: p.tipo_respuesta || p.tipo || '',
      opciones: p.opciones ?? [],
      variantes: [],
      criterios: [],
    })
  })
}

async function sincronizarPreguntasConBanco(idIndicador: number): Promise<boolean> {
  if (!authStore.esAdmin && !authStore.tienePermiso('banco.gestionar')) {
    mostrarMensaje(
      'El instrumento fue guardado, pero no se generó el formulario porque tu usuario no tiene permiso para gestionar el banco de preguntas.',
      'error'
    )
    return false
  }

  const grupos = instrumentoSeleccionado.value?.grupos_interes ?? []
  if (grupos.length === 0) return true

  // Fase 1: cargar banco actual para detectar duplicados
  loadingMensaje.value = 'Cargando banco de preguntas...'
  await bancoStore.cargarBanco()

  // Recopilar todas las preguntas de todos los grupos
  const pendientes: Array<{ enunciado: string; tipo: string; id_grupo_interes: number | null; opciones: string[]; id_pregunta_banco: number | null }> = []
  for (const g of grupos) {
    for (const p of g.preguntas ?? []) {
      pendientes.push({
        enunciado: p.enunciado ?? '',
        tipo: p.tipo_respuesta ?? '',
        id_grupo_interes: g.id_grupo_interes ?? null,
        opciones: p.opciones ?? [],
        id_pregunta_banco: p.id_pregunta_banco ?? null,
      })
    }
  }
  if (pendientes.length === 0) return true

  // Fase 2: crear en el banco las preguntas que no existan, acumular IDs
  loadingMensaje.value = 'Registrando preguntas en el banco...'
  // Separar las que ya tienen ID (lookup síncrono) de las que hay que crear
  const idsPorIndice: (number | undefined)[] = new Array(pendientes.length)
  const aCrear: Array<{ idx: number; pq: typeof pendientes[0] }> = []

  for (let i = 0; i < pendientes.length; i++) {
    const pq = pendientes[i]
    if (pq.id_pregunta_banco) {
      idsPorIndice[i] = pq.id_pregunta_banco
      continue
    }
    const enunciado = pq.enunciado.trim().toLowerCase()
    const existente = bancoStore.preguntasBanco.find(
      b => (b.enunciado ?? b.pregunta ?? '').trim().toLowerCase() === enunciado
    )
    if (existente?.id_pregunta) {
      idsPorIndice[i] = existente.id_pregunta
      continue
    }
    aCrear.push({ idx: i, pq })
  }

  // Crear en banco en paralelo
  const resultadosCrear = await Promise.allSettled(
    aCrear.map(({ pq }) => bancoStore.crearPregunta({
      pregunta: pq.enunciado,
      tipo: pq.tipo,
      id_grupo_interes: pq.id_grupo_interes,
      opciones: pq.opciones,
    }))
  )
  for (let i = 0; i < resultadosCrear.length; i++) {
    const r = resultadosCrear[i]
    const { idx } = aCrear[i]
    if (r.status === 'rejected' || !r.value.ok) {
      mostrarMensaje('No se pudo registrar la pregunta en el banco.', 'error')
      return false
    }
    if (!r.value.data?.id_pregunta) {
      mostrarMensaje('El banco no devolvió el ID de la pregunta creada.', 'error')
      return false
    }
    idsPorIndice[idx] = r.value.data.id_pregunta
  }
  const idsPreguntasBanco = idsPorIndice.filter((id): id is number => id != null)

  // Fase 3: vincular al indicador en paralelo
  loadingMensaje.value = 'Vinculando preguntas al indicador...'
  const resultadosAsign = await Promise.allSettled(
    idsPreguntasBanco.map(idPregunta => bancoStore.asignarAIndicadores(idPregunta, [idIndicador]))
  )
  for (const r of resultadosAsign) {
    if (r.status === 'rejected' || !r.value.ok) {
      const val = r.status === 'fulfilled' ? r.value : { ok: false, status: 0, errors: {} }
      const msg = (val as any).status === 403
        ? 'Sin permiso para vincular preguntas al indicador. Contacta a un coordinador o administrador.'
        : primerError(val as any)
      mostrarMensaje(`No se pudo vincular la pregunta al indicador: ${msg}`, 'error')
      return false
    }
  }

  return true
}

function agregarPreguntaLocal(grupo: any) {
  if (!requiereGruposYPreguntas() || !grupo) return
  grupo.preguntas.push({
    id_temp: Date.now(),
    enunciado: enunciadoPregunta.value,
    tipo_respuesta: tipoPregunta.value,
    variantes: tipoPregunta.value === 'opinion' ? [...variantesOpinion.value] : [],
    criterios: tipoPregunta.value === 'opinion' ? [...criteriosOpinion.value] : [],
    opciones: construirOpcionesPregunta()
  })
  cancelarPregunta()
}

function abrirCopia(pregunta: any) {
  if (preguntaCopiar.value === pregunta) {
    cancelarCopia()
    return
  }
  preguntaCopiar.value = pregunta
  gruposCopiaDestino.value = []
}

function cancelarCopia() {
  preguntaCopiar.value = null
  gruposCopiaDestino.value = []
}

async function copiarPreguntaAGrupos() {
  if (!preguntaCopiar.value || gruposCopiaDestino.value.length === 0) return
  copiando.value = true
  await new Promise(r => setTimeout(r, 0))

  const base = Date.now()
  const todosGrupos = instrumentoSeleccionado.value?.grupos_interes ?? []
  const yaExiste: string[] = []
  const copiados: string[] = []

  todosGrupos.forEach((g: any, i: number) => {
    const key = g.id_temp ?? g.id_grupo_interes
    if (!gruposCopiaDestino.value.includes(key)) return
    const duplicado = (g.preguntas ?? []).some(
      (p: any) => p.enunciado?.trim().toLowerCase() === preguntaCopiar.value.enunciado?.trim().toLowerCase()
    )
    if (duplicado) {
      yaExiste.push(g.nombre)
      return
    }
    g.preguntas.push({
      id_temp: base + i,
      enunciado: preguntaCopiar.value.enunciado,
      tipo_respuesta: preguntaCopiar.value.tipo_respuesta,
      variantes: [...(preguntaCopiar.value.variantes ?? [])],
      criterios: [...(preguntaCopiar.value.criterios ?? [])],
      opciones: [...(preguntaCopiar.value.opciones ?? [])]
    })
    copiados.push(g.nombre)
  })

  copiando.value = false
  cancelarCopia()

  if (copiados.length > 0) {
    mostrarMensaje(`Pregunta copiada a: ${copiados.join(', ')}`, 'positivo')
  }
  if (yaExiste.length > 0) {
    mostrarMensaje(`La pregunta ya existe en: ${yaExiste.join(', ')}`, 'error')
  }
}

function quitarGrupo(grupo: any) {
  if (!instrumentoSeleccionado.value?.grupos_interes) return

  instrumentoSeleccionado.value.grupos_interes = instrumentoSeleccionado.value.grupos_interes.filter(
    (g: any) => (g.id_temp || g.id_grupo_interes) !== (grupo.id_temp || grupo.id_grupo_interes)
  )

  if (grupoActivo.value && (grupoActivo.value.id_temp || grupoActivo.value.id_grupo_interes) === (grupo.id_temp || grupo.id_grupo_interes)) {
    grupoActivo.value = null
  }
}

async function guardarInstrumento() {
  if (loadingAccion.value) return
  feedback.value = ''
  loadingMensaje.value = 'Guardando instrumento...'
  loadingAccion.value = true
  try {
    if (!nombreInstrumento.value) {
      mostrarMensaje('No hay instrumento seleccionado, se detiene la función', 'error')
      return
    }

    if (requiereGruposYPreguntas()) {
      const grupos: any[] = instrumentoSeleccionado.value?.grupos_interes ?? []
      const tieneGrupoConPregunta = grupos.some(g => (g.preguntas?.length ?? 0) > 0)
      if (grupos.length === 0 || !tieneGrupoConPregunta) {
        mostrarMensaje('Debe agregar al menos un grupo de interés con al menos una pregunta antes de guardar.', 'error')
        return
      }
    }

    if (modoEdicion.value && editandoInstrumento.value?.id_instrumento) {
      const idInst = editandoInstrumento.value.id_instrumento

      const payloadUpdate = {
        herramienta: nombreInstrumento.value,
        descripcion: descripcionInstrumento.value,
        id_tipo_componente: props.idTipoComponente
      }

      const actualizado = await instrumentoStore.actualizarInstrumento(idInst, payloadUpdate)
      if (!actualizado) {
        mostrarMensaje('No se pudo actualizar el instrumento', 'error')
        return
      }

      if (requiereGruposYPreguntas()) {
        const gruposIds: number[] = []

        const gruposInteresModif = instrumentoSeleccionado.value?.grupos_interes || []

        // Crear grupos nuevos en paralelo
        await Promise.allSettled(
          gruposInteresModif
            .filter((g: any) => !g.id_grupo_interes)
            .map(async (g: any) => {
              const grupoCreado = await grupoStore.crearGrupo({
                nombre: g.nombre,
                tipo_muestreo: g.tipo_muestreo,
                criterios: g.criterios
              })
              if (grupoCreado?.id_grupo_interes) g.id_grupo_interes = grupoCreado.id_grupo_interes
            })
        )

        // Recopilar IDs y preguntas pendientes
        const preguntasPendientesModif: Array<{ p: any; idGrupoInteres: number }> = []
        for (const g of gruposInteresModif) {
          const idGrupoInteres: number | null = g.id_grupo_interes ?? null
          if (idGrupoInteres !== null) {
            gruposIds.push(idGrupoInteres)
            for (const p of g.preguntas) {
              if (p.id_temp && !p.id_pregunta) preguntasPendientesModif.push({ p, idGrupoInteres })
            }
          }
        }

        // Crear preguntas en paralelo
        await Promise.allSettled(
          preguntasPendientesModif.map(({ p, idGrupoInteres }) => preguntaStore.crearPregunta({
            enunciado: p.enunciado,
            pregunta: p.enunciado,
            tipo_respuesta: p.tipo_respuesta,
            tipo: p.tipo_respuesta,
            opciones: p.opciones,
            id_instrumento: idInst,
            id_grupo_interes: idGrupoInteres,
            orden: p.orden ?? null
          }))
        )

        if (gruposIds.length > 0) {
          await instrumentoStore.asignarGrupos(idInst, gruposIds)
        }
      }

      if (requiereGruposYPreguntas() && vigenciaDesde.value && vigenciaHasta.value) {
        loadingMensaje.value = 'Registrando preguntas en el banco...'
        const sincrOk = await sincronizarPreguntasConBanco(props.idIndicador)
        if (!sincrOk) return
        loadingMensaje.value = 'Generando formulario de Google Forms...'
        const configResult = await configStore.crear({
          id_instrumento: idInst,
          id_indicador: props.idIndicador,
          vigencia_desde: vigenciaDesde.value,
          vigencia_hasta: vigenciaHasta.value,
          titulo: nombreFormulario.value.trim() || undefined,
          instrucciones: instruccionesFormulario.value.trim() || undefined
        })
        if (configResult.ok && configResult.data?.id_configuracion) {
          await configStore.publicar(configResult.data.id_configuracion)
        } else if (!configResult.ok) {
          mostrarMensaje(`Instrumento guardado. No se generó el formulario: ${primerError(configResult)}`, 'error')
          return
        }
      }

      sessionStorage.setItem('instrumento_creado', 'Instrumento actualizado correctamente')
      emit('cerrar')
      return
    }

    const nuevo = await instrumentoStore.crearInstrumento({
      herramienta: nombreInstrumento.value,
      descripcion: descripcionInstrumento.value,
      id_tipo_componente: props.idTipoComponente
    })
    if (!nuevo?.id_instrumento) {
      mostrarMensaje('No se creó el instrumento correctamente', 'error')
      return
    }

    const relacion = await indicadorInstrumentoStore.crearRelacion({
      id_indicador: props.idIndicador,
      id_instrumento: nuevo.id_instrumento
    })
    if (!relacion?.id) {
      mostrarMensaje('No se pudo vincular el indicador con el instrumento', 'error')
      return
    }

    if (requiereGruposYPreguntas()) {
      const gruposIds: number[] = []
      const preguntasPendientes: Array<{ p: any; idGrupoInteres: number }> = []

      const gruposInteresCr = instrumentoSeleccionado.value?.grupos_interes || []

      // Crear grupos nuevos en paralelo
      await Promise.allSettled(
        gruposInteresCr
          .filter((g: any) => !g.id_grupo_interes)
          .map(async (g: any) => {
            const grupoCreado = await grupoStore.crearGrupo({
              nombre: g.nombre,
              tipo_muestreo: g.tipo_muestreo,
              criterios: g.criterios
            })
            if (grupoCreado?.id_grupo_interes) g.id_grupo_interes = grupoCreado.id_grupo_interes
          })
      )

      // Recopilar IDs y preguntas
      for (const g of gruposInteresCr) {
        const idGrupoInteres: number | null = g.id_grupo_interes ?? null
        if (idGrupoInteres !== null) {
          gruposIds.push(idGrupoInteres)
          for (const p of g.preguntas) {
            preguntasPendientes.push({ p, idGrupoInteres })
          }
        }
      }

      if (gruposIds.length > 0) {
        await grupoStore.asignarGruposAInstrumento(nuevo.id_instrumento, gruposIds)
      }

      // Crear preguntas en paralelo
      await Promise.allSettled(
        preguntasPendientes.map(({ p, idGrupoInteres }) => preguntaStore.crearPregunta({
          enunciado: p.enunciado,
          pregunta: p.enunciado,
          tipo_respuesta: p.tipo_respuesta,
          tipo: p.tipo_respuesta,
          opciones: p.opciones,
          id_instrumento: nuevo.id_instrumento,
          id_grupo_interes: idGrupoInteres,
          orden: p.orden ?? null
        }))
      )
    }

    if (requiereGruposYPreguntas() && vigenciaDesde.value && vigenciaHasta.value) {
      loadingMensaje.value = 'Registrando preguntas en el banco...'
      const sincrOk = await sincronizarPreguntasConBanco(props.idIndicador)
      if (!sincrOk) return
      loadingMensaje.value = 'Generando formulario de Google Forms...'
      const configResult = await configStore.crear({
        id_instrumento: nuevo.id_instrumento,
        id_indicador: props.idIndicador,
        vigencia_desde: vigenciaDesde.value,
        vigencia_hasta: vigenciaHasta.value,
        titulo: nombreFormulario.value.trim() || undefined,
        instrucciones: instruccionesFormulario.value.trim() || undefined
      })
      if (configResult.ok && configResult.data?.id_configuracion) {
        await configStore.publicar(configResult.data.id_configuracion)
      } else if (!configResult.ok) {
        mostrarMensaje(`Instrumento guardado. No se generó el formulario: ${primerError(configResult)}`, 'error')
        return
      }
    }

    sessionStorage.setItem('instrumento_creado', `Instrumento "${nuevo.herramienta}" creado correctamente`)
    emit('cerrar')
  } catch (err: any) {
    console.error('Error al guardar instrumento completo:', err)
    mostrarMensaje(err?.message || 'Error al guardar instrumento completo', 'error')
  } finally {
    loadingAccion.value = false
  }
}

function cancelarPregunta() {
  mostrarFormPregunta.value = false
  tipoPregunta.value = ''
  enunciadoPregunta.value = ''
  opcionesPregunta.value = []
  opcionesTextoPregunta.value = ''
  escalaMinPregunta.value = 1
  escalaMaxPregunta.value = 5
  etiquetaMinPregunta.value = ''
  etiquetaMaxPregunta.value = ''
  variantesOpinion.value = []
  criteriosOpinion.value = []
}

function eliminarPregunta(grupo: any, id_temp: number) {
  grupo.preguntas = grupo.preguntas.filter((p: any) => p.id_temp !== id_temp)
}

function salir() {
  emit('cerrar')
}
</script>

<style scoped>
/* ===================== Paleta ===================== */
.modal-overlay {
  --azul: #0e69a0;
  --azul-cl: #e8f1f8;
  --azul-txt: #0c447c;
  --amarillo: #eea222;
  --tinta: #1e2a35;
  --mute: #5b6b7a;
  --linea: #d9e1ea;
  --bg: #f4f7fa;

  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
  box-sizing: border-box;
}

.modal-contenido {
  width: 95%;
  max-width: 1080px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
  background: var(--bg);
}

.wrap { background: var(--bg); }

/* Encabezado sticky */
.top {
  background: var(--azul);
  color: #fff;
  padding: 18px 26px;
  border-radius: 14px 14px 0 0;
  position: sticky;
  top: 0;
  z-index: 5;
}
.top h1 { margin: 0; font-size: 20px; font-weight: 700; }
.top p  { margin: 4px 0 0; color: #cfe0ec; font-size: 13px; }

main { padding: 22px 26px 28px; }

/* Estado */
.estado-bar { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.25rem; }
.estado-label { font-weight: 600; font-size: 0.9rem; color: var(--mute); }
.estado-badge {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: capitalize;
}
.estado-edicion      { background: #e8f4fd; color: #0e69a0; }
.estado-aprobado     { background: #d4edda; color: #155724; }
.estado-asignado     { background: #fff3cd; color: #856404; }
.estado-completado   { background: #d1ecf1; color: #0c5460; }
.estado-descontinuado { background: #f8d7da; color: #721c24; }

/* Tarjetas */
.card {
  background: #fff;
  border: 1px solid var(--linea);
  border-radius: 12px;
  padding: 18px 20px;
  margin: 0 0 18px;
  box-shadow: 0 1px 3px rgba(30,50,80,.05);
}
.card h2 { margin: 0 0 12px; font-size: 17px; color: #111; font-weight: 700; }

.sub-card {
  border: 1px solid var(--linea);
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 14px;
  background: #fcfdfe;
}
.sub-card h3,
.sub-card h4 { margin: 0 0 12px; font-size: 14px; color: #111; font-weight: 700; }

/* Filas selector */
.fila-selector {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}
.input-flex { flex: 1; min-width: 220px; }

/* Form */
.card-desc { color: var(--mute); font-size: 0.88rem; margin: 0 0 1rem; line-height: 1.5; }
.form-row { display: flex; gap: 1rem; flex-wrap: wrap; }
.form-row .form-group { flex: 1; min-width: 180px; }
.form-group { margin-bottom: 1rem; display: flex; flex-direction: column; }
.form-group label { margin-bottom: 0.4rem; font-weight: 600; font-size: 0.88rem; color: var(--tinta); }

input, select, textarea {
  width: 100%;
  border: 1px solid var(--linea);
  border-radius: 8px;
  padding: 0.6rem 0.7rem;
  font-family: inherit;
  font-size: 0.95rem;
  color: var(--tinta);
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}
textarea { resize: vertical; min-height: 60px; }
input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: var(--azul);
  box-shadow: 0 0 0 3px rgba(14,105,160,0.15);
}

/* Grupos vinculados */
.grupos-vinculados {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--linea);
}
.grupos-vinculados h3 {
  margin: 0 0 10px;
  font-size: 14px;
  color: #111;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
}

.grupo-selector { display: flex; gap: 0.6rem; margin-bottom: 1rem; flex-wrap: wrap; }
.copia-panel {
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid var(--linea);
  border-radius: 8px;
  background: var(--azul-cl);
}
.copia-titulo {
  margin: 0 0 8px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--azul-txt);
}
.grupos-check-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid var(--linea);
  border-radius: 8px;
  background: #fff;
  max-height: 120px;
  overflow-y: auto;
  margin-bottom: 8px;
}
.grupo-check-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.87rem;
  cursor: pointer;
}
.grupo-check-item input { width: 15px; height: 15px; cursor: pointer; }
.grupo-btn {
  padding: 0.55rem 1.1rem;
  border: 1px solid var(--linea);
  border-radius: 8px;
  background: #eef2f7;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--mute);
  transition: all 0.15s ease;
}
.grupo-btn.active { background: var(--azul); color: #fff; border-color: var(--azul); }

.hint-seleccionar-grupo {
  margin-top: 6px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 10px 14px;
  text-align: center;
}

.hint-seleccionar-flecha {
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 4px;
}

.hint-flecha-item {
  display: inline-block;
  width: 100%;
  max-width: 120px;
  font-size: 1.1rem;
  color: var(--amarillo);
  font-weight: 700;
  animation: pulso-flecha 1.2s ease-in-out infinite;
}

.hint-seleccionar-texto {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #92400e;
}

.preguntas-panel {
  background: #fcfdfe;
  border: 1px solid var(--linea);
  border-radius: 10px;
  padding: 14px 16px;
}
.preguntas-head { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.preguntas-head h4 { margin: 0; font-size: 14px; color: #111; font-weight: 700; }
.pill {
  display: inline-block;
  background: var(--azul-cl);
  color: var(--azul-txt);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 700;
}

/* Preguntas */
.q {
  border: 1px solid var(--linea);
  border-radius: 10px;
  padding: 12px 14px;
  margin: 0 0 12px;
  background: #fff;
}
.qh { display: flex; gap: 8px; align-items: flex-start; margin-bottom: 8px; flex-wrap: wrap; }
.qn {
  background: var(--azul);
  color: #fff;
  border-radius: 6px;
  min-width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex: none;
}
.qt { font-weight: 600; color: var(--tinta); }
.tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  border-radius: 5px;
  padding: 2px 8px;
  background: var(--azul-cl);
  color: var(--azul-txt);
  white-space: nowrap;
}
.opciones { margin: 6px 0 0; padding-left: 1.2rem; list-style: disc; }
.opciones li { margin-bottom: 4px; }
.rating { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; margin-top: 6px; }
.rating-opt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  border-radius: 6px;
  background: var(--azul-cl);
  color: var(--azul-txt);
  font-weight: 700;
  font-size: 0.82rem;
}
.resp-show {
  background: #f7fafc;
  border: 1px solid var(--linea);
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 14px;
}
.muted { color: var(--mute); font-style: italic; }

/* Tabla opinión */
.tabla-opinion { margin-top: 10px; overflow-x: auto; }
.tabla-evaluacion { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
.tabla-evaluacion th,
.tabla-evaluacion td { border: 1px solid var(--linea); padding: 10px 12px; text-align: center; }
.tabla-evaluacion th {
  background: var(--azul-cl);
  color: var(--azul-txt);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
}
.tabla-evaluacion td:first-child { text-align: left; font-weight: 500; background: #fafafa; }
.tabla-evaluacion input[type="checkbox"] { cursor: not-allowed; accent-color: var(--azul); }

/* Botones */
.botones { display: flex; gap: 0.75rem; margin-top: 1rem; flex-wrap: wrap; justify-content: flex-end; }
.botones-finales { margin-top: 1.5rem; padding-top: 1.25rem; border-top: 1px solid var(--linea); }

.btn {
  padding: 0.6rem 1.3rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.92rem;
  font-family: inherit;
}
.btn:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-sm { padding: 0.4rem 0.9rem; font-size: 0.82rem; }

.btn.salir { background: #fff; border: 1px solid #ccc; color: #333; }
.btn.salir:hover:not(:disabled) { background: #d41a1a; color: #fff; border-color: #d41a1a; }
.btn.guardar { background: var(--amarillo); color: #000; }
.btn.guardar:hover:not(:disabled) { background: var(--azul); color: #fff; }
.btn.vincular { background: var(--azul); color: #fff; }
.btn.vincular:hover:not(:disabled) { background: var(--azul-txt); }

@keyframes pulso-flecha {
  0%, 100% { transform: translateY(0); opacity: 1; }
  50% { transform: translateY(-4px); opacity: 0.6; }
}

@media (max-width: 768px) {
  main { padding: 16px; }
  .fila-selector { flex-direction: column; align-items: stretch; }
  .input-flex { min-width: 0; }
  .botones { flex-direction: column; align-items: stretch; }
  .grupo-selector { flex-direction: column; }
  .tabla-evaluacion th,
  .tabla-evaluacion td { font-size: 0.8rem; padding: 0.4rem; }
}
</style>
